<template>
  <li>
    <a :href="download" target="_blank">
      <div>
        <span class="family">{{ family }}</span>
        <span class="foundry">{{ foundry }}</span>
      </div>
    </a>
  </li>
</template>

<script>
  export default {
    name: "directory-item",
    props: {
      family: String,
      foundry: String,
      download: String
    }
  }
</script>

<style lang="scss" scoped>
  li {
    margin-bottom: 0.5rem;
  }
  div {
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    transition: all 250ms;

    a:hover & {
      border-bottom-color: #000;
    }
  }
  .family {
    font-size: 0.875rem;
  }
  .foundry {
    font-size: 0.75rem;
    color: #8c8c8c;
    transition: all 250ms;

    a:hover & {
      color: #000;
    }
  }
</style>